import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "add_circle", -1)
const _hoisted_2 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_3 = { class: "flex-grow-1" }
const _hoisted_4 = { class: "table table-hover table-v2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("th", null, " ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_modal_button = _resolveComponent("base-modal-button")!
  const _component_input_text = _resolveComponent("input-text")!
  const _component_dp_form = _resolveComponent("dp-form")!
  const _component_base_modal = _resolveComponent("base-modal")!
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_PopupOverviewItem = _resolveComponent("PopupOverviewItem")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_BaseTitle, {
        title: _ctx.$t('popups'),
        mb: 4,
        "show-refresh-button": "",
        onRefresh: _ctx.reloadContent
      }, {
        buttons: _withCtx(() => [
          (_ctx.pageUI.isReady())
            ? (_openBlock(), _createBlock(_component_base_modal_button, {
                key: 0,
                class: "btn btn-hover icon-link",
                "modal-id": _ctx.modalId
              }, {
                default: _withCtx(() => [
                  _hoisted_1,
                  _createTextVNode(_toDisplayString(_ctx.$t('add')), 1)
                ]),
                _: 1
              }, 8, ["modal-id"]))
            : _createCommentVNode("", true),
          _createVNode(_component_base_modal, {
            "modal-id": _ctx.modalId,
            "dialog-classes": "modal-sm",
            title: _ctx.$t('popup')
          }, {
            footer: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_base_modal_button, {
                  mode: "close",
                  class: "btn btn-outline-primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_base_modal_button, {
                  ref: "createButton",
                  onClick: _ctx.createPopup,
                  mode: "close",
                  class: "btn btn-primary ms-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('create')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_dp_form, {
                as: "form",
                novalidate: "",
                ref: "popupForm",
                onSubmit: _ctx.clickCreate
              }, {
                default: _withCtx(({ errors }) => [
                  _createVNode(_component_input_text, {
                    modelValue: _ctx.newPopupName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newPopupName) = $event)),
                    label: _ctx.$t('name'),
                    name: "newPopupName",
                    rules: "required|min:3",
                    errors: errors
                  }, null, 8, ["modelValue", "label", "errors"])
                ]),
                _: 1
              }, 8, ["onSubmit"])
            ]),
            _: 1
          }, 8, ["modal-id", "title"])
        ]),
        _: 1
      }, 8, ["title", "onRefresh"]),
      _createVNode(_component_AlertError2, {
        error: _ctx.pageUI.getError()
      }, null, 8, ["error"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _hoisted_5,
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('name')), 1),
              _hoisted_6
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getPopups, (popup) => {
              return (_openBlock(), _createBlock(_component_PopupOverviewItem, {
                key: popup.id,
                popup: popup,
                onDelete: _ctx.deletePopup,
                onUpdateStatus: _ctx.updateStatus
              }, null, 8, ["popup", "onDelete", "onUpdateStatus"]))
            }), 128))
          ])
        ])
      ])
    ]),
    _: 1
  }))
}